import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import SearchBand from "@/pages/home/components/SearchBand";
import LatestVideos from "@/pages/home/components/LatestVideos";
import HotRanking from "@/pages/home/components/HotRanking";
import AboutIntro from "@/pages/home/components/AboutIntro";
import { videos } from "@/mocks/videos";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta(
    "黄色免费视频 - 高清免费视频资源在线观看平台",
    "黄色免费视频为您提供丰富多样的免费视频资源，涵盖多种分类，方便用户在线浏览和观看各类免费视频内容。",
    "黄色免费视频,免费视频,免费视频资源,在线免费视频,免费视频在线观看,免费视频平台,免费视频内容",
  );

  const featured = videos.filter((v) => v.featured);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <h1 className="sr-only">黄色免费视频 - 高清免费视频资源在线观看平台</h1>
        <HeroCarousel videos={featured} />
        <CategoryGrid />
        <SearchBand />
        <LatestVideos />
        <HotRanking />
        <AboutIntro />
      </main>
      <SiteFooter />
    </div>
  );
}